import { mount } from "svelte";
import App from "./App.svelte";
import { applyShareState, art } from "./lib/state/params.svelte";
import { decodeHash } from "./lib/state/url";

// Decode the share URL into the store BEFORE the app (and engine) mounts.
const shared = decodeHash(location.hash);
if (shared) applyShareState(shared);

// Reduced motion: start paused — the canvas shows a still first frame.
if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  art.paused = true;
}

const app = mount(App, {
  target: document.getElementById("app")!,
});

export default app;
